import { Component, OnInit, ViewChild } from '@angular/core';
import { OrganisationSettingsService } from '../../services/organisation-settings.service';

@Component({
  selector: 'adminapp-site-profile-wrapper',
  templateUrl: './site-profile-wrapper.component.html',
  styleUrls: ['./site-profile-wrapper.component.scss']
})
export class SiteProfileWrapperComponent implements OnInit {

  @ViewChild('confirmSiteTypeModal') saveSiteTypeModal;
  @ViewChild('siteProfileLayout') siteProfileLayout;

  organizationId: String;
  isSaveButtonEnabled: boolean;
  constructor(private organisationSettingsService: OrganisationSettingsService) {
    this.organizationId = sessionStorage.getItem('organizationid');
    this.organisationSettingsService.setOrganisationId(this.organizationId);
    this.isSaveButtonEnabled = false;
  }

  ngOnInit() {

  }

  handleSaveButtonClicked() {
    this.siteProfileLayout.openSiteTypeSaveModal();
  }

  enableSaveButton($eventValue) {
    this.isSaveButtonEnabled = $eventValue;
  }

}
